export default __webpack_public_path__ + "static/media/GunHai.17a8cd0f.jpg";